import type { SportConfig } from '../types/sport';

export const tableTennisConfig: SportConfig = {
  id: 'table_tennis',
  name: { ru: 'Настольный теннис', en: 'Table Tennis' },
  icon: 'table_tennis',
  color: '#EC4899',
  defaults: {
    teamMode: 'pairs',
    scoringMode: 'sets',
    maxParticipants: 2,
    durationMinutes: 30,
    teamsCount: 2,
    hasParticipantLimit: true,
    participantStep: 2,
  },
  scoring: {
    type: 'sets',
    labels: { ru: ['Игрок А', 'Игрок Б'], en: ['Player A', 'Player B'] },
  },
  shuffle: null,
  ratings: { enabled: true, scale: { min: 1, max: 5 }, anonymous: true },
  mvp: { enabled: false, perTeam: false },
  positions: null,
  supportsMultiMatch: false,
  playersPerTeam: 1,
};
